import React from "react";
import './SeccionFrase.css';

function SeccionFrase() {
  return (
    <section className="seccion-frase">
      <div className="frase-container">
        <h2 className="home-subtitle">Simple Ideas</h2>
        <div className="frase-subtext">
          <p>Simple Ideas nace bajo la inspiración de la mirada de los pequeños detalles de la vida...un gesto, un momento, una emoción, una sensación que está presente en el ahora, en este instante y logra ser capturada para la posteridad en esa bella imagen fotográfica.</p>
          <p>Siempre fui un amante de la naturaleza, de todo lo que nos rodea, sea grande o pequeño, ínfimo o majestuoso, llamativo u oculto, brillante u oscuro...todo me dice algo, me habla, y quiere quedarse, permanecer, para no desaparecer, como si quisiera prolongar su vida más allá de su existencia.</p>
          <p>Es mi deseo poder transmitir con mis fotos, momentos únicos que cada uno puede vislumbrar y apreciar a su manera, como aquello que está ahí y muchas veces no vemos…</p>
          <p>Es por esto que quiero compartir con uds. mucho más que imágenes. Es el querer compartir deseos, sensaciones y recuerdos de momentos únicos.</p>
        </div>
      </div>
    </section>
  );
}
export default SeccionFrase;
